<template>
  <!-- <Layout> -->
    <div>
    <div class="pageHeader">


      <div class="content">

          <div v-if="isShowSpinner" class="row">
              <div class="col-12 text-center">
                  <b-spinner variant="dark" ></b-spinner>
              </div>
          </div>

          <div v-if="!isShowSpinner && !cart" class="row mt-2 pt-4" style="min-height:350px;">
            <div class="col-12 text-center">
                <span class="text-warning font-weight-bold font-size-16">Vous n'avez aucun article dans votre panier</span>

                <p class="text-dark font-size-16 mt-2">
                        Explorer notre <a class="text-warning font-weight-bold" href="/sac-personnalise/">catalogue d'articles</a> pour trouver des produits qui vous inspirent !
                    </p>

            </div>
          </div>

          <div v-if="deliveryFreethreshold && cartDeliveryFreePercent"  class="mb-3">
            <div class="deliveryTitle">
              <span>Livraison gratuite à partir de {{ deliveryFreethreshold }}</span><span class="break-line"></span><span> d’achats !</span>
            </div>
            <!-- <div class="slider mt-4 mt-md-0">
              <div class="fill" 
                  :style="'background: linear-gradient(to right, #20c997 0%, #20c997 ' + cartDeliveryFreePercent + '%, #eaeaea ' + cartDeliveryFreePercent + '%, #eaeaea 100%)'"></div>
            </div> -->
          </div>
      </div>
    </div>
    
    <CartItems v-if="!isShowSpinner && cart" :cart="cart" ></CartItems>
  </div>
  <!-- </Layout> -->
</template>
<script>

// import Layout from "../../layouts/main";
import CartItems from "./cartItems.vue";


export default ({
  name: "Cart",
  components: {
    /*Layout, */CartItems
  },

  created() {
    //this.$store.dispatch('fetchCart');
  },

  mounted() {
  },

  data() {
        return {
            cart: null,
        };
  },

  computed: {

        deliveryFreethreshold() {
          if (!this.cart || !this.cart.deliveryMode) {
            return null;
          }
          return this.cart.deliveryMode.deliveryFreeThresholdStr;
        },

        deliveryName() {
          if (!this.cart || !this.cart.deliveryMode) {
            return null;
          }
          return this.cart.deliveryMode.name;
        },

        cartDeliveryFreePercent() {
          if (!this.cart || !this.cart.lines) {
            return null;
          }
          return this.cart.lines.cartDeliveryFreePercent;
        },

        isShowSpinner() {
          return this.$store.state.isLoadingCart;
        }
  },

  watch: {
        '$store.state.cart': {
            handler(newCart) {
                this.cart = newCart;
            },
            deep: true,
        },
  },

  methods: {



  }
})
</script>
        
        
        
<style scoped>

.pageHeader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fff;
}

/* Web view */
@media only screen and (min-width: 601px) {
  .pageHeader {
    padding-top: 4%;
  }
}

/* Mobile view */
@media only screen and (max-width: 600px) {
  .pageHeader {
    padding-top: 5%;
  }
}

.deliveryTitle {
  position: relative;
  top: 0px;
  left: 0px;
  display: inline-block;
  width: 100%;
  text-align: center;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  font-size: 16px;
  color: #121212;
  
}




.break-line {
  display: none;
}

@media only screen and (max-width: 600px) {
  .break-line {
    display: block;
    width: 100%;

  }
}


.elementscartcartGoal {
  width: 100%;
  position: relative;

}

.slider {
  width: 100%;
  height: 45px;

}

.fill {
  position: relative;
  top: 70%;
  left: 0;
  width: 100%;
  height: 7px;

  transform: translateY(-50%);
  border-radius: 45px;
}

.sliderIcon {
  position: relative;
  top: 70%;
  transform: translate(-60%, -60%);
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: white;
  border: 10px solid white;
}

/* Mobile view */
</style>